"use strict";

var _classCallCheck = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/build_9f461b9a/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

exports.implementation =
/*#__PURE__*/
function () {
  function NavigatorPluginsImpl() {
    _classCallCheck(this, NavigatorPluginsImpl);
  }

  _createClass(NavigatorPluginsImpl, [{
    key: "javaEnabled",
    // plugins and mimeTypes are implemented in Navigator-impl.js
    value: function javaEnabled() {
      return false;
    }
  }]);

  return NavigatorPluginsImpl;
}();